"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectContactData.name': 'Detección de Datos de Contacto',
    'tools.detectContactData.description': 'Detecta y extrae automáticamente información de contacto como números de teléfono, correos electrónicos, direcciones y nombres de los mensajes del usuario',
};
